import { render, staticRenderFns } from "./CQSDeletionModal.vue?vue&type=template&id=10c6dc34&scoped=true&"
import script from "./CQSDeletionModal.vue?vue&type=script&lang=js&"
export * from "./CQSDeletionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6dc34",
  null
  
)

export default component.exports